<template>
    <transition name="slide-fade" >
        <div>
           <div class="uk-padding">
               <div class="uk-container uk-container-small">
                   <h1 class="uk-heading-line uk-text-center"><span>Accountant Review Services</span></h1>
                   <!--<h3 class="uk-heading-bullet h2Style">Financial Statement Audit</h3>
                   <p>
                       FINCOR is fully licensed by the Cayman Islands Institute of Professional
                       Accountants (CIIPA) for the provision of financial statement audits. This
                       work involves the examination of financial statements and accompanying
                       disclosures to arrive at an opinion regarding the fairness of their
                       presentation.
                   </p>
                   <p>
                       We provide services to private companies, non-profit organizations,
                       charities and public agencies.
                   </p>-->
               </div>
           </div>
           <div class="uk-padding uk-background-muted">
               <div class="uk-container uk-container-small">
                   <h3 class="uk-heading-bullet h2Style">Accountant Review</h3>
                   <p>
                       An Accountant Review provides limited assurance that no material
                       changes are needed to bring the financial statements into compliance with
                       the applicable financial reporting framework. It is based on the execution
                       of analytical procedures and inquiries, to ascertain whether the
                       information contained within the financial statements is correct.
                   </p>
                   <p>
                       This process provides limited assurance that the financial statements do
                       not require material modifications.
                   </p>
                   <p>
                       An Accountant Review typically does not entail detailed examination of
                       source documents, third party confirmations, tests of controls or physical
                       inspection (for example of inventory on hand).
                   </p>
               </div>
           </div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Agreed upon procedures</h3>
                    <p>
                        Agreed upon procedures typically examine a specific criteria or business
                        process. Our report is typically restricted to certain parties, and only
                        includes factual findings. Opinions, conclusions or assurances are not
                        usually provided under Agreed Upon Procedures.
                    </p>
                    <p>
                        An example of this would be a company wishing to provide evidence of
                        compliance with a statutory calculation for the payment of fees.
                    </p>
                </div>
            </div>
            <div class="uk-padding uk-background-muted">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Internal Control evaluations</h3>
                    <ul class="uk-list uk-list-bullet">
                        For clients seeking an evaluation of their internal controls, we will typically
                        perform procedures to determine:
                        <li>The existence of checks and balances;</li>
                        <li>The extent to which controls are being used;</li>
                        <li>Appropriate segregation of duties;</li>
                        <li>Safeguarding of records;</li>
                        <li>Adequacy of policies and procedures; and</li>
                        <li>The level of training and competence of employees.</li>
                    </ul>
                    <p>
                        This examination usually results in FINCOR providing a set of
                        recommendations to the client on ways to improve the system of internal
                        controls.
                    </p>

                </div>
            </div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Compliance</h3>
                    <p>
                        Our compliance service provides clients with reasonable assurance that
                        the entity is complying with applicable laws, internal codes of conduct,
                        policies, procedures, rule and regulation.
                    </p>
                    <p>
                        This work provides comfort regarding adherence to the prevailing laws,
                        rules and workforce policies. This is a critical component of a three line of
                        defense system in effective corporate governance.
                    </p>
                </div>
            </div>
            <div class="uk-padding uk-background-muted">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet h2Style">Financial Due Diligence Reports</h3>
                    <p>
                        Our financial due diligence work investigates the records of a
                        potential company to be acquired, to confirm that the financial
                        representations of the seller are supported by the financial records, and
                        are verifiable.
                    </p>
                    <p>
                        We look at revenue trends, liquidity, the market, asset base, receivables
                        and payables, and provide a report to the client outlining our findings. This
                        work enables the purchase transaction to be completed from an informed
                        perspective, and also provides assurance to financial institutions who may
                        be financing the acquisition.
                    </p>
                </div>
            </div>
          <ContactStrip />
        </div>
    </transition>
</template>

<script>
    import ContactStrip from "@/components/parts/ContactStrip.vue";

    export default {
        name: "auditAndAssurance",
      components: {ContactStrip},
      metaInfo: {
        title: ' Accountant Review Financial Services',
        meta: [{
          content: 'At FINCOR we provide limited assurance that the financial statements do not require material modifications for our clients while offering other related services such as: Agreed upon procedures, Internal Control evaluations, Compliance and Financial Due Diligence Reports'
        }]
      }
    }
</script>

<style scoped>
    .h2Style{
        font-family: 'Overlock SC';
    }
</style>